<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div v-if="apiConnection.status == true" class="container-fluid">
      <Breadcrumbs main="DMRV" :path="breadcrumbPath" />

      <!-- radio group control tap -->
      <div class="row px-2 m-0" :class="$vuetify.display.width >= 1400 ? 'mt-30' : $vuetify.display.width >= 768 ? 'mt-30' : $vuetify.display.width >= 375 ? 'mt-24' : 'mt-20'">
        <el-col
          :span="
            $vuetify.display.width >= 1300
              ? 24
              : $vuetify.display.width < 750
              ? 24
              : 24
          "
          class="px-2"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >

          <el-row :span="24">
            <el-col :span="12" style="min-width: 320px;">
              <el-radio-group
                v-model="uploadFilter"
                text-color="#ffff"
                fill="#234B49"
                :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
              >
                <el-radio-button
                  v-model="tabController"
                  :id="uploadFilter == `1` ? `Recommended-Upload-button` : `Recommended-Upload-button-disactive`"
                  class="start-period all-group-by text-center"
                  label="1"
                  @click="tabController = true"
                  :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
                >
                  Monitoring Reports
                </el-radio-button>
                <el-radio-button
                  v-model="tabController"
                  :id="uploadFilter == `2` ? `Simple-Upload-button` : `Simple-Upload-button-disactive`"
                  class="site-group-by text-center end-period"
                  @click="tabController = false"
                  label="2"
                  :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
                >
                  Projects
                </el-radio-button>
              </el-radio-group>
            </el-col>

            <!-- MP creat component -->

              <el-col v-show="tabController" v-if="openCreate || openSend" :span="$vuetify.display.width >= 1300 ? 12 : 24" >
                <el-row
                  :class="$vuetify.display.width >= 1300 ? 'justify-end wrap-gap-20' : 'mt-20 justify-start wrap-gap-10'"
                  :style="$vuetify.display.width >= 1300 ? 'flex-wrap: wrap; gap: 20px; justify-content: flex-end;' : 'margin-top: 20px; gap: 10px;'">
                    <el-col
                    :style="{
                      maxWidth: '232px',
                      minWidth: screenWidth < 750 ? '100%' : '232px',
                      height: '40px'
                    }" >
                      <el-row v-if="openCreate" class="m-0 width-100-p" style="max-width: 232px; height: 40px; margin-right: 20px; align-items: end;">
                        <!-- section for create verramp -->
                        <el-col  class="d-flex align-item-center mb-20" :span="$vuetify.display.width < 1500 ? 24 : 24">

                          <div class="row m-0 width-100-p">
                            <div
                              class="row m-0 py-3 width-100-p bg-me-primary border-color-light b-r-10"
                            >
                              <el-col :span="24" class="d-flex align-items-center px-0">
                                    <el-image
                                      class="arrow-btn"
                                      style="width: 14px; height: 14px;  margin-right: 10px;"
                                      :src="
                                          require('@/assets/arrow-right.png')
                                        "
                                      fit="cover"
                                      @click="handleOpenCreatetoChild"
                                    />
                                  <span class="openButtonText">Create monitoring report</span>
                              </el-col>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>

                    <el-col :span="12"
                    :style="{
                      maxWidth: '220px',
                      minWidth: screenWidth < 750 ? '100%' : '220px',
                      height: '40px'
                    }">
                      <el-row v-if="openSend" class="m-0 width-100-p" style="max-width: 220px; height: 40px; align-items: end;">
                        <!-- section for create verramp -->
                        <el-col class="d-flex align-item-center mb-20" :span="$vuetify.display.width < 1500 ? 24 : 24">

                          <div class="row m-0 width-100-p">
                            <div
                              class="row m-0 py-3 width-100-p bg-me-primary border-color-light b-r-10"
                            >
                              <el-col :span="24" class="d-flex align-items-center px-0">
                                    <el-image
                                      class="arrow-btn"
                                      style="width: 14px; height: 14px; margin-right: 10px;"
                                      :src="
                                          require('@/assets/arrow-right.png')
                                        "
                                      fit="cover"
                                      @click="handleOpenSendtoChild"
                                    />
                                  <span class="openButtonText">Send monitoring report</span>
                              </el-col>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                </el-row>
              </el-col>

          </el-row>
        </el-col>
      </div>

      <!-- show when radio tab label === 'monitoring_reports' -->
      <el-row v-if="tabController" class="m-0 width-100-p mt-3">

        <!-- MP list component -->
        <el-col  class="row px-0 mb-20 m-0" :span="24">
            <mpList @childOpen="handleChildOpen" ref="childMplist" @sendVerraMP="handleSendVerraMP" />
        </el-col>

        <!-- verra list table -->
        <el-col class="d-flex align-item-center" :span="24">
          <div class="row m-0 width-100-p px-2">
            <div
              class="row px-0  py-3 mb-20 m-0 width-100-p bg-me-primary border-color-light rounded-4"
            >
              <el-col class="mb-2" :span="24">
                <div class="row m-0">
                  <!-- mp list table search and input less 700 screen size -->
                  <el-col
                    :span="$vuetify.display.width >= 1200 ? 12 : 24"
                    class="d-flex align-item-center"
                    :class="
                      $vuetify.display.width < 750
                        ? 'x-center mt-2'
                        : 'justify-start'
                    "
                  >
                      <el-input
                          size="large"
                          v-model="search"
                          placeholder="Type to search by ID, Project ID, Standard Template ..."
                          :prefix-icon="Search"
                          class="mixedSearchBar-2"
                          id="mixedSearchBar-input-2"
                          clearable
                          @clear="handleReload"
                        >
                          <template #append>
                            <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                          </el-button>
                          </template>
                      </el-input>

                      <el-tooltip
                        effect="light"
                        placement="top"
                        show-after="500"
                        hide-after="200"
                        >
                        <template #content >
                            <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Refresh the table content" }} </span>
                        </template>
                      <el-button
                        class="new-download-file-btn new-button-behavior ml-2"
                        @click.stop="handleRefresh"
                      >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newRefreshButton"></use>
                        </svg>
                      </el-button>
                      </el-tooltip>
                  </el-col>

                </div>
              </el-col>

              <!-- Verra MP list table -->
              <DataTable
                :loadingProp="loading"
                :usersDataProp="displayTableData"
                :totalRowProp="total_items"
                @tableAction="handleTableAction"
              />
            </div>
          </div>
        </el-col>

      </el-row>

      <!-- show when radio tab label === 'projects' -->
      <!-- project description table -->
      <el-row v-if="!tabController" class="m-0 width-100-p mt-3">
        <!-- verra list table -->
        <el-col class="d-flex align-item-center" :span="24">
          <div class="row m-0 width-100-p px-2">
            <div
              class="row px-0  py-3 mb-20 m-0 width-100-p bg-me-primary border-color-light rounded-4"
            >
              <el-col class="mb-2" :span="24">
                <div class="row m-0">
                  <!-- mp list table search and input less 700 screen size -->
                  <el-col
                    :span="$vuetify.display.width >= 1200 ? 12 : 24"
                    class="d-flex align-item-center"
                    :class="
                      $vuetify.display.width < 750
                        ? 'x-center mt-2'
                        : 'justify-start'
                    "
                  >
                    <el-input
                        size="large"
                        v-model="searchProjectDescription"
                        placeholder="Type to search by ID, Standard Template, Standard Template Name ..."
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReloadProjectDescription"
                      >
                        <template #append>
                          <el-button
                          @click.stop="handleReloadProjectDescription"
                          class="newSearchButtonClass"
                        >
                        <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                        </template>
                      </el-input>
                      <el-tooltip
                        effect="light"
                        placement="top"
                        show-after="500"
                        hide-after="200"
                        >
                        <template #content >
                            <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Refresh the table content" }} </span>
                        </template>

                      <el-button
                        class="new-download-file-btn new-button-behavior ml-2"
                        @click.stop="handleRefresh"
                      >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newRefreshButton"></use>
                        </svg>
                      </el-button>
                      </el-tooltip>
                  </el-col>


                </div>
              </el-col>

              <!-- Verra MP list table -->
              <dataTableMpReports
                :loadingProp="loadingProjectDescription"
                :usersDataProp="displayProjectDescriptionTableData"
                :totalRowProp="total_itemsProjectDescription"
                @tableAction="handleTableActionProjectDescription"
              />
            </div>
          </div>
        </el-col>
      </el-row>

      <viewMore
        :open_modal="show_modal"
        :data_modal="data_modal"
        :data_comment="data_comment"
        @close_modal="close_modal"
      />


    </div>

    <div v-if="apiConnection.status == false" class="container-fluid flex flex-wrap gap-20">
      <Breadcrumbs main="DMRV" :path="breadcrumbPath" />
      <div class="row px-2 m-0 x-y-center" :class="$vuetify.display.width >= 1400 ? 'mt-30' : $vuetify.display.width >= 768 ? 'mt-30' : $vuetify.display.width >= 375 ? 'mt-24' : 'mt-20'">
          <el-card class="bg-me-primary border-color-light rounded-4 x-y-center" style="width: 480px" shadow="always">
                <span class="text-white mt-20">Lost connection to Verra API</span>
                <br>
                <span class="text-white mt-20">{{ apiConnection.message }}</span>
                <br>
                <span v-if="apiConnection.msgFromVerraAPI" class="text-white mt-20">Error message from Verra API response: </span>
                <br>
                <span class="text-white mt-20">{{ apiConnection.msgFromVerraAPI }}</span>
          </el-card>
      </div>
    </div>
  </template>

  <script>
  import Breadcrumbs from "../../../components/bread_crumbs.vue";

  import UserService from "../../../services/user.service";
  import DataTable from "./dataTable.vue";
  import mpList from "./mpList.vue";

  import dataTableMpReports from "./dataTableMpReports.vue";

  import { createLoadingInstance } from "../common/common-tools";
  import { ElMessageBox } from "element-plus";

  import viewMore from "./viewMore.vue";

  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "baselines",
    components: {
      Breadcrumbs,

      DataTable,
      mpList,

      dataTableMpReports,

      viewMore,
    },
    data() {
      return {
        openCreate: false,
        openSend: false,

        uploadFilter: "1",

        apiConnection: {
          status: true,
          message: "",
          msgFromVerraAPI: "",
        }, // false if lost connection to verra api


        tabController: true, // switch monitoring reports or project descriptions

        breadcrumbPath: [
          {
            title: "General",
            disabled: true,
            href: "",
          },
          {
            title: "DMRV",
            disabled: false,
            href: "/dashboard-DMRV",
            active: true,
          },
        ],

        show: true,

        verraMPlist: [],
        beforeSearch: [],
        searchResult: [],
        displayTableData:[],
        search: "",
        current_page: 0,
        page_size: 50,
        total_items: 100,
        perPageCount: 50,


        loading: false,
        show_modal: false,
        data_modal: null,
        current_row_index: null,
        filterOpen: false,

        // project description table
        loadingProjectDescription: false,
        ProjectDescriptionList:[],
        beforeSearchProjectDescription: [],
        searchProjectDescription: "",
        searchProjectDescriptionResult: [],
        total_searchProjectDescription_items: 100,
        displayProjectDescriptionTableData:[],
        current_pageProjectDescription: 0,
        page_sizeProjectDescription: 50,
        total_itemsProjectDescription: 100,
        perPageCountProjectDescription: 50,


      };
    },
    watch: {
      tabController: {
        handler: function (newVal) {
          if (newVal == true) {
            this.fetchVerraMPlist();
          }
          if (newVal == false) {
            this.fetchDmrvGetProjectDescription();
          }
      },
      deep: true,
      immediate: true,
    },


      // pagination and search for mp list
      verraMPlist: {
        handler: "applySearch",
        immediate: true,
      },

      searchResult: {
        handler: "handlePaginatedData",
        immediate: true,
      },

      current_page: {
        handler: "handlePaginatedData",
        immediate: true,
      },

      page_size: {
        handler: "handlePaginatedData",
        immediate: true,
      },
      // pagination and search

      // pagination and search for project description
      ProjectDescriptionList: {
        handler: "applySearchProjectDescription",
        immediate: true,
      },

      searchProjectDescriptionResult: {
        handler: "handlePaginatedDataProjectDescription",
        immediate: true,
      },

      current_pageProjectDescription: {
        handler: "handlePaginatedDataProjectDescription",
        immediate: true,
      },

      page_sizeProjectDescription: {
        handler: "handlePaginatedDataProjectDescription",
        immediate: true,
      },
      // pagination and search
    },
    computed: {
      filter_baseline() {

        return this.verraMPlist;
      },

      // pagination for table data
      paginatedData() {
        let start = (this.current_page - 1 ) * this.page_size;
        let end = (start + this.page_size) >= this.searchResult.length ? (this.searchResult.length) : (start + this.page_size);
        let data = this.searchResult;
        return data.slice(start, end);
      },

      paginatedDataProjectDescription() {
        let start = (this.current_pageProjectDescription - 1 ) * this.page_sizeProjectDescription;
        let end = (start + this.page_sizeProjectDescription) >= this.searchProjectDescriptionResult.length ? (this.searchProjectDescriptionResult.length) : (start + this.page_sizeProjectDescription);
        let data = this.searchProjectDescriptionResult;
        return data.slice(start, end);
      },
    },
    // mounted() {
    //   this.fetchVerraMPlist();
    //   this.fetchDmrvGetProjectDescription();
    // },
    methods: {

      handleChildOpen(create, send) {
        // console.log("child event", create, send);

        this.openCreate = !create;
        this.openSend = !send;

      },

      handleOpenCreatetoChild() {
        this.$refs.childMplist.handleOpenCreateFromParent();
      },
      handleOpenSendtoChild() {
        this.$refs.childMplist.handleOpenSendFromParent();
      },

      // convertLabel(str) {
      //   return convertToTitleCase(str);
      // },



      handlePaginatedData() {
        this.displayTableData = this.paginatedData;
        // this.loadingBarChart = false;
      },

      handlePaginatedDataProjectDescription() {
        this.displayProjectDescriptionTableData = this.paginatedDataProjectDescription;
        // this.loadingBarChart = false;
      },

      applySearch(){
        let search = this.search;
        // console.log("call search", search);

        if (search != "") {
          const term = search.toString().toLowerCase().trim();
          this.searchResult = [];
          let Result = this.beforeSearch.filter((item) =>
            item.id?.toString().toLowerCase().includes(term) ||
            item.projectId?.toString().toLowerCase().includes(term)||
            item.standardTemplate?.toString().toLowerCase().includes(term)||
            item.standardTemplateName?.toString().toLowerCase().includes(term)||
            item.methodologyTemplate?.toString().toLowerCase().includes(term)||
            item.monitoringReportName?.toString().toLowerCase().includes(term)||
            item.projectName?.toString().toLowerCase().includes(term)||
            item.submissionStatus?.toString().toLowerCase().includes(term)
          );

          this.searchResult = Result;
          this.total_items = Result.length;

        } else {
          let Result = this.beforeSearch;
          this.searchResult = Result;
          this.total_items = Result.length;
        }

      },

      applySearchProjectDescription(){
        let search = this.searchProjectDescription;
        // console.log("call search", search);

        if (search != "") {
          const term = search.toString().toLowerCase().trim();
          this.searchProjectDescriptionResult = [];
          let Result = this.beforeSearchProjectDescription.filter((item) =>
            item.id?.toString().toLowerCase().includes(term) ||
            item.standardTemplate?.toString().toLowerCase().includes(term)||
            item.standardTemplateName?.toString().toLowerCase().includes(term)||
            item.methodologyTemplate?.toString().toLowerCase().includes(term)||
            item.projectName?.toString().toLowerCase().includes(term)||
            item.submissionStatus?.toString().toLowerCase().includes(term)
          );

          this.searchProjectDescriptionResult = Result;
          this.total_searchProjectDescription_items = Result.length;

        } else {
          let Result = this.beforeSearchProjectDescription;
          this.searchProjectDescriptionResult = Result;
          this.total_searchProjectDescription_items = Result.length;
        }

      },

      handleRefresh() {
        if(this.tabController == true) {
          this.fetchVerraMPlist();
        } else {
          this.fetchDmrvGetProjectDescription();
        }
      },

      handleSendVerraMP(sendVerraMPName, selectedMpData) {
        // console.log("received from child", sendVerraMPName, selectedMpData);
        if(selectedMpData && sendVerraMPName && sendVerraMPName != "") {
          let start_date = selectedMpData[0].start_date;
          let end_date = selectedMpData[0].end_date;
          let mp_id = selectedMpData[0].id;
          this.sendVerraMPlist(sendVerraMPName, start_date, end_date, mp_id);
        } else {
          console.log("received empty mpname or mpdata");
          const MessageBox = `
                  <span class="moderat-meGreen">A Monitoring period must be selected from the dropdown.</span><br/>
                  `;

          return ElMessageBox.alert(MessageBox, {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }).then(()=> {return;}).catch(()=>{return;});
        }
      },

      fetchDmrvGetProjectDescription() {
        this.loadingProjectDescription = true;
        UserService.DmrvGetProjectDescription().then(
          (response) => {
            // console.log("res project description", response.data);
            if(!response) {
              this.apiConnection = {
                status: false,
                message: "No response from server",
                msgFromVerraAPI: "No response from server",
              };
            }
            else if(response.status == 200) {
              this.ProjectDescriptionList = response.data;
              this.beforeSearchProjectDescription = response.data;
              this.total_itemsProjectDescription = response.data.length;
            }
            else {
              this.apiConnection = {
                status: false,
                message: response.data.message,
                msgFromVerraAPI: response.data.message,
              };
              this.ProjectDescriptionList = [];
              this.beforeSearchProjectDescription = [];
              this.total_itemsProjectDescription = 0;
              this.loadingProjectDescription = false;
            }
          },
          (err) => {
            console.log("error from response of project description request with message: ", err.message);
              // console.log(err);
              if (err.response.status == 401 || err.response.status == 403) {
                this.$router.push({
                  path: "/",
                });
              }
              else {
                this.apiConnection = {
                  status: false,
                  message: err.message,
                  msgFromVerraAPI: err.response.data.message,
                };
                this.ProjectDescriptionList = [];
                this.beforeSearchProjectDescription = [];
                this.total_itemsProjectDescription = 0;
                this.loadingProjectDescription = false;
              }
          }
        ).then(()=>{
              this.current_pageProjectDescription = 1;
              this.page_sizeProjectDescription = 50;
        }).catch((err) => {
          console.log("error when send request to get project description", err.message);
            this.ProjectDescriptionList = [];
            this.beforeSearchProjectDescription = [];
            this.total_itemsProjectDescription = 0;
            this.loadingProjectDescription = false;
            // console.log(err);
            if (err.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }

        }).finally(()=>{
          this.loadingProjectDescription=false;
        });
      },


      fetchVerraMPlist() {
        this.loading = true;
        let request = {
          selected_send_mp_name: "",
        };
        UserService.getVerraMonitoringReportsList(request)
          .then(
            (response) => {
                // console.log("response", response);
              if(!response) {
                this.apiConnection = {
                  status: false,
                  message: "No response from server",
                  msgFromVerraAPI: "No response from server",
                };
              }
              else if(response.status == 200) {
              this.verraMPlist = response.data;
                this.beforeSearch = response.data;
                this.total_items = response.data.length;
              }
              else {
                this.apiConnection = {
                  status: false,
                  message: response.data.message,
                  msgFromVerraAPI: response.data.message,
                };
                this.verraMPlist = [];
                this.beforeSearch = [];
                this.total_items = 0;
                this.loading = false;
              }

            },
            (err) => {
              console.log("error from response of verra monitoring period list request with message: ", err.message);
              if (err.response.status == 401 || err.response.status == 403) {
                this.$router.push({
                  path: "/",
                });
              }
              else {
                this.apiConnection = {
                  status: false,
                  message: err.message,
                  msgFromVerraAPI: err.response.data.message,
                };
                this.ProjectDescriptionList = [];
                this.beforeSearchProjectDescription = [];
                this.total_itemsProjectDescription = 0;
                this.loadingProjectDescription = false;
              }
            }
          ).then(
            () => {

              this.current_page = 1;
              this.page_size = 50;

            }
          )
          .catch((error) => {
            this.verraMPlist = [];
            this.beforeSearch = [];
            this.total_items = 0;
            this.loading = false;
            console.log(error.message);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          })
          .finally(() => {
          this.loading = false});
      },

      async sendVerraMPlist(sendVerraMPName, mp_start_date, mp_end_date, mp_id) {
        if (sendVerraMPName == "" || !mp_start_date || !mp_end_date) {
          console.log("send VerraMPlist failed");
        }
        let request = {
          selected_send_mp_name: sendVerraMPName || "",
        };

        const loadingInstance = createLoadingInstance('Finding monitoring report ...');
        await UserService.getVerraMonitoringReportsList(request)
          .then(
            async (response) => {
                // if success send id to VerraSendMonitoringReportsShayan
                if(response.data.code == 1000) {

                  loadingInstance.close();

                  const loadingInstanceSecond = createLoadingInstance('Sending monitoring report ...');

                  const id_to_send = response.data.data.id;

                  // console.log("id to send to next", id_to_send);

                  let newRequest = {
                    verra_mp_id_from_response: id_to_send,
                    mp_id: mp_id,
                    mp_name: sendVerraMPName,
                    start_date: mp_start_date,
                    end_date: mp_end_date
                  }

                  // console.log("new request to send to next", newRequest);

                  await UserService.VerraSendMonitoringReportsShayan(newRequest).then((newResponse)=>{
                    loadingInstanceSecond.close();
                    const newResponseMessage = newResponse.data.message;
                    // console.log("new resp", newResponse.data);
                    const MessageBox = `
                      <span class="moderat-meGreen">${newResponseMessage}</span><br/>
                      `;

                       ElMessageBox.alert(MessageBox,
                        {
                          confirmButtonText: "OK",
                          type: newResponse.data.code == 1001 ? "warning" : newResponse.data.code == 1000 ? "success" : "error",
                          dangerouslyUseHTMLString: true,
                        }).then(()=>{return;}).catch(()=>{return;});
                      return;

                  }).catch((newError)=>{
                    loadingInstanceSecond.close();
                    // console.log("new ERROR", newError);
                    const mainMessage = newError?.message || "";
                    // const backendMessage = newError?.response?.data?.message || "";
                    const backendMessage = newError?.response?.data?.message || newError?.message || "Unknown error";

                    const MessageBox = `
                      <span class="moderat-meGreen">${mainMessage}</span><br/>
                      <span class="moderat-meGreen">${backendMessage}</span><br/>
                      `;
                    ElMessageBox.alert(MessageBox,
                    {
                      confirmButtonText: "OK",
                      type: "error",
                      dangerouslyUseHTMLString: true,
                    }).then(()=>{return;}).catch(()=>{return;});
                    console.log("error when send id to verra-send-mp-json");
                  });

                } else {
                  loadingInstance.close();
                  const responseMessage = response.data.message;
                  const MessageBox = `
                  <span class="moderat-meGreen">${responseMessage}</span><br/>
                  `;
                  await ElMessageBox.alert(MessageBox, {
                    confirmButtonText: "OK",
                    type: response.data.code == 1000 ? "success" : response.data.code == 1002 ? "warning" : "error",
                    dangerouslyUseHTMLString: true,
                  }).then(()=> {}).catch(()=>{console.log("error when send mp list");
                    return;
                  });
                  console.log("request not success before send mp json.");
                  return;
                }


            },
            (error) => {
              loadingInstance.close();

              const message = error?.response?.data?.message || "";
              const fallback = error?.message || "";

              const MessageBox = `
                      <span class="moderat-meGreen">${fallback}</span><br/>
                      <span class="moderat-meGreen">${message}</span><br/>
                      `;

              ElMessageBox.alert(MessageBox,
               {
                 confirmButtonText: "OK",
                 type: "error",
                 dangerouslyUseHTMLString: true,
               }).then(()=>{return;}).catch(()=>{return;});

            }
          ).catch((error) => {
            console.log(error.message);
          })
          .finally(() => {
          this.loading = false});
      },

      confirm_modal(event) {
        if (this.verraMPlist.length == this.current_row_index)
          this.verraMPlist.push(event);
        else this.verraMPlist[this.current_row_index] = event;
        this.show_modal = false;
      },

      handleShow(data) {
        this.data_modal = data.data;
        this.show_modal = true;
      },

      paginate(array, page_size, page_number) {
        return array.slice(
          (page_number - 1) * page_size,
          page_number * page_size
        );
      },


      reset_filter(event) {
        this.current_page = 1;
        this.search = "";
        this.filter = event.filter;
      },

      handleTableAction(event) {
          if (event.kind == "viewMore") {
            this.handleShow(event.data);
          } else if (event.kind == "changePage") {
          this.current_page = event.index;
          // this.fetchVerraMPlist(this.current_page);
        } else if (event.kind == "perPageChange") {
          this.current_page = 1;
          this.page_size = event.index;
          this.perPageCount = event.index;
          this.handleReload();
        }
      },

      close_modal() {
        this.show_modal = false;
      },

      handleReload() {
        // this.fetchVerraMPlist(this.current_page);
        this.current_page = 1;
        this.applySearch(this.search);
      },

      handleTableActionProjectDescription(event) {
        if (event.kind == "edit") {
          this.handleShow(event.index, event.data);
        } else if (event.kind == "delete") {
          this.deleteRow(event.data, event.index);
        } else if (event.kind == "changePage") {
          this.current_pageProjectDescription = event.index;
          // this.fetchVerraMPlist(this.current_page);
        } else if (event.kind == "perPageChange") {
          this.current_pageProjectDescription = 1;
          this.page_sizeProjectDescription = event.index;
          this.perPageCountProjectDescription = event.index;
          this.handleReloadProjectDescription();
        }
      },

      handleReloadProjectDescription() {
        // this.fetchVerraMPlist(this.current_page);
        this.current_pageProjectDescription = 1;
        this.applySearchProjectDescription(this.searchProjectDescription);
      },

      filterSearch(event) {
        this.search = event.search;
      },


    },
  };
  </script>

  <style>
  .el-table .warning-row {
    --el-table-tr-bg-color: var(--el-color-warning-light-8);
  }
  .el-table .error-row {
    --el-table-tr-bg-color: var(--el-color-error-light-8);
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .cell {
    text-align: center !important;
  }

  .starter-main .card-body ul {
    list-style-type: none !important;
  }

  .el-pager {
    -webkit-user-select: none !important;
    user-select: none !important;
    list-style: none !important;
    font-size: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    position: relative !important;
    top: 0 !important;
    right: 0 !important;
  }

  .el-upload-list {
    margin: 10px 0 0 !important;
    padding: 0 !important;
    list-style: none !important;
    position: relative !important;
  }

  .openButtonText {
    color: var(--White, #FFF);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.5px;
    text-align: end;
  }
  </style>
